import React, {
  } from "react";
  import {
    withRouter
  } from "react-router";
  
  import TermsOfUseMui from "../core/TermsOfUseMui";

  const TermsOfUsePage = (props) => {
    const closeModal = () => {
        
    }
  
  
    return (
      <div>
           <TermsOfUseMui closeModal={closeModal} noButtons={true} isFullScreen={true}></TermsOfUseMui>   
      </div>
    );
  };
  
  export default withRouter(TermsOfUsePage);